var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "18", height: "18", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement(
      "defs",
      null,
      React.createElement(
        "radialGradient",
        { id: "loading-gradient", cx: "9", cy: "9", r: "9", fx: "0%", fy: "50%" },
        React.createElement("stop", { offset: "0%", stopColor: "#fff" }),
        React.createElement("stop", { offset: "69%", stopColor: "#a5a5a5" }),
        React.createElement("stop", { offset: "100%" })
      )
    ),
    React.createElement("circle", { r: "7.5", cx: "9", cy: "9", strokeWidth: "2", stroke: "url(#loading-gradient)", fill: "none" })
  );
});